// REACT
import React from 'react';

import { toolbarLinkStyles } from './styles';

/*

Props:
- linkHandler (function)

Child: 
- custom link text

*/

let componentStyles = { ...toolbarLinkStyles }

const _applyStyleModifiers = (props) => {
    return {...componentStyles}
}

export const ToolbarLink = (props) => {
    
    const styles = {...componentStyles, ..._applyStyleModifiers(props)}

    return (
        <div style={ styles.container }>
            <button onClick={ props.onClick(props.target) } style={ styles.linkStyles}>
                {props.children}
            </button>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/js/components/ToolbarLink/ToolbarLink.jsx